/* I Luminari 3D — technical drawings, one per shop category.
   Same register as the crown and the rosone in theme.js: gold strokes (.bp), faint construction
   lines (.bp-thin) and LED points (.led-dot), on a -210..210 grid. Every stroke has pathLength 1,
   so theme.js can trace it on load or on scroll. Picked by key through data-blueprint="…". */
(function () {
  'use strict';
  var LU = window.LU = window.LU || {};
  var NS = 'http://www.w3.org/2000/svg';
  var R = Math.PI / 180;

  function el(tag, a, p) {
    var e = document.createElementNS(NS, tag);
    for (var k in a) e.setAttribute(k, a[k]);
    if (p) p.appendChild(e);
    return e;
  }
  function s(tag, a, p, cls) { a.pathLength = 1; a['class'] = cls || 'bp'; return el(tag, a, p); }
  function P(d, p) { return s('path', { d: d }, p); }
  function T(d, p) { return s('path', { d: d }, p, 'bp bp-thin'); }
  function C(cx, cy, r, p, thin) { return s('circle', { cx: cx, cy: cy, r: r }, p, thin ? 'bp bp-thin' : 'bp'); }
  function E(cx, cy, rx, ry, p, thin) { return s('ellipse', { cx: cx, cy: cy, rx: rx, ry: ry }, p, thin ? 'bp bp-thin' : 'bp'); }
  function led(x, y, p, r) { return el('circle', { cx: f(x), cy: f(y), r: r || 3.6, 'class': 'led-dot' }, p); }
  function G(p, tf) { return el('g', tf ? { transform: tf } : {}, p); }
  function f(n) { return (Math.round(n * 10) / 10).toString(); }
  function pt(x, y) { return f(x) + ' ' + f(y); }
  function poly(pts, close) { return 'M' + pts.map(function (q) { return pt(q[0], q[1]); }).join(' L') + (close ? 'Z' : ''); }
  function polar(r, deg, cx, cy) { return [(cx || 0) + Math.cos(deg * R) * r, (cy || 0) + Math.sin(deg * R) * r]; }
  function ngon(n, r, rot, cx, cy) { var a = []; for (var i = 0; i < n; i++) a.push(polar(r, rot + i * 360 / n, cx, cy)); return a; }
  function star(n, R1, R2, rot, cx, cy) { var a = []; for (var i = 0; i < n * 2; i++) a.push(polar(i % 2 ? R2 : R1, rot + i * 180 / n, cx, cy)); return a; }
  function svg() { return el('svg', { viewBox: '-210 -210 420 420', 'aria-hidden': 'true', 'class': 'bp-svg', focusable: 'false' }); }

  /* construction set: circle, cross-hair, optional tick ring */
  function frame(g, o) {
    o = o || {};
    var c = G(g);
    if (o.r !== 0) C(0, o.cy || 0, o.r || 176, c, true);
    if (o.cross !== false) { T('M-200 ' + (o.cy || 0) + ' H200', c); T('M0 -200 V200', c); }
    if (o.ticks) for (var t = 0; t < 72; t++) {
      var a = t * 5, r2 = t % 6 === 0 ? 192 : 186, p1 = polar(182, a), p2 = polar(r2, a);
      T('M' + pt(p1[0], p1[1]) + ' L' + pt(p2[0], p2[1]), c);
    }
    return c;
  }
  /* dimension line under the drawing, like the crown */
  function dim(g, half, y) {
    y = y || 200;
    T('M' + -half + ' ' + y + ' H' + half, g);
    T('M' + (-half + 8) + ' ' + (y - 5) + ' L' + -half + ' ' + y + ' L' + (-half + 8) + ' ' + (y + 5) +
      ' M' + (half - 8) + ' ' + (y - 5) + ' L' + half + ' ' + y + ' L' + (half - 8) + ' ' + (y + 5) +
      ' M' + -half + ' ' + (y - 12) + ' V' + (y + 6) + ' M' + half + ' ' + (y - 12) + ' V' + (y + 6), g);
  }
  function sample(fn, a, b, n) { var o = []; for (var i = 0; i <= n; i++) o.push(fn(a + (b - a) * i / n)); return o; }

  /* Luci da notte: crescent moon and stars */
  LU.luna = function () {
    var g = svg(); frame(g, { ticks: true });
    var oc = [-12, 6], orr = 118, ic = [34, -26], irr = 100;
    var dx = ic[0] - oc[0], dy = ic[1] - oc[1], d = Math.hypot(dx, dy);
    var a = (orr * orr - irr * irr + d * d) / (2 * d), h = Math.sqrt(orr * orr - a * a);
    var mx = oc[0] + a * dx / d, my = oc[1] + a * dy / d;
    var p1 = [mx + h * dy / d, my - h * dx / d], p2 = [mx - h * dy / d, my + h * dx / d];
    var ang = function (c, q) { return Math.atan2(q[1] - c[1], q[0] - c[0]) / R; };
    // arc from a0 to a1 (either way round) that passes through the angle "via"
    var through = function (a0, a1, via) {
      var cands = [a1 - 720, a1 - 360, a1, a1 + 360, a1 + 720];
      for (var i = 0; i < cands.length; i++) {
        var lo = Math.min(a0, cands[i]), hi = Math.max(a0, cands[i]);
        if (hi - lo >= 360) continue;
        for (var v = via - 720; v <= via + 720; v += 360) if (v > lo && v < hi) return [a0, cands[i]];
      }
      return [a0, a1];
    };
    var oA = through(ang(oc, p1), ang(oc, p2), 180), iA = through(ang(ic, p2), ang(ic, p1), 180);
    var oa = oA[0], ob = oA[1];
    var outer = sample(function (t) { return polar(orr, t, oc[0], oc[1]); }, oA[0], oA[1], 64);
    var inner = sample(function (t) { return polar(irr, t, ic[0], ic[1]); }, iA[0], iA[1], 64);
    C(oc[0], oc[1], orr, g, true);
    P(poly(outer.concat(inner), true), g);
    var sg = ob > oa ? 1 : -1, inset = sample(function (t) { return polar(orr - 14, t, oc[0], oc[1]); }, oa + sg * 34, ob - sg * 34, 48);
    T(poly(inset), g);
    [[96, -112, 24], [146, -36, 13], [52, -156, 11], [150, 70, 9]].forEach(function (q) {
      P(poly(star(4, q[2], q[2] * 0.32, -90, q[0], q[1]), true), g); led(q[0], q[1], g);
    });
    dim(g, 130);
    return g;
  };

  /* Tradizione: arch of a Puglia luminaria gallery */
  LU.arco = function () {
    var g = svg(); var c = G(g);
    T('M-200 172 H200', c); T('M0 -200 V200', c); C(0, -20, 168, c, true);
    P('M-128 172 V-20 A128 128 0 0 1 128 -20 V172', g);
    P('M-104 172 V-20 A104 104 0 0 1 104 -20 V172', g);
    T('M-116 172 V-20 A116 116 0 0 1 116 -20 V172', g);
    for (var i = 0; i < 9; i++) { var a = 180 + i * 22.5, q = polar(80, a, 0, -20), q2 = polar(104, a, 0, -20); T('M' + pt(q[0], q[1]) + ' L' + pt(q2[0], q2[1]), g); }
    // scallops between the rings
    var sc = [];
    for (var k = 0; k <= 16; k++) { var aa = 180 + k * 11.25; sc.push(polar(k % 2 ? 80 : 92, aa, 0, -20)); }
    P(poly(sc), g);
    C(0, -20, 34, g); P(poly(star(8, 30, 12, -90, 0, -20), true), g); led(0, -20, g);
    P('M0 -148 L-12 -164 L0 -192 L12 -164Z', g);
    for (var j = 0; j <= 12; j++) { var b = polar(116, 180 + j * 15, 0, -20); led(b[0], b[1], g); }
    for (var y = 0; y <= 160; y += 32) { led(-116, y, g); led(116, y, g); }
    P('M-146 172 H-86 M86 172 H146', g);
    return g;
  };

  /* Supereroi Marvel: hero emblem with a lightning bolt */
  LU.fulmine = function () {
    var g = svg(); frame(g, { ticks: true });
    P(poly(ngon(6, 152, -90), true), g);
    T(poly(ngon(6, 132, -90), true), g);
    C(0, 0, 112, g, true);
    P('M22 -118 L-58 14 L-6 14 L-30 118 L58 -24 L6 -24 L36 -118Z', g);
    ngon(6, 142, -90).forEach(function (q) { led(q[0], q[1], g); });
    dim(g, 132);
    return g;
  };

  /* Supereroi DC: domino mask */
  LU.maschera = function () {
    var g = svg(); frame(g, {});
    P('M0 -22 C40 -64 138 -76 172 -34 C190 -4 158 52 104 54 C62 56 32 22 0 22 C-32 22 -62 56 -104 54 C-158 52 -190 -4 -172 -34 C-138 -76 -40 -64 0 -22Z', g);
    P('M28 -10 C46 -36 104 -40 128 -14 C140 2 118 26 86 26 C56 26 34 10 28 -10Z', g);
    P('M-28 -10 C-46 -36 -104 -40 -128 -14 C-140 2 -118 26 -86 26 C-56 26 -34 10 -28 -10Z', g);
    T('M0 -22 C30 -50 120 -62 160 -30 M0 -22 C-30 -50 -120 -62 -160 -30', g);
    T('M172 -34 L196 -46 M-172 -34 L-196 -46', g);
    dim(g, 172, 110);
    return g;
  };

  function heartPts(k, n) {
    return sample(function (t) {
      var x = 16 * Math.pow(Math.sin(t), 3);
      var y = -(13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t));
      return [x * k, y * k + 10];
    }, 0, Math.PI * 2, n);
  }
  /* Amore: heart */
  LU.cuore = function () {
    var g = svg(); frame(g, { ticks: true });
    C(-62, -58, 64, g, true); C(62, -58, 64, g, true);
    P(poly(heartPts(9, 120), true), g);
    T(poly(heartPts(7.4, 120), true), g);
    heartPts(8.2, 24).slice(0, 24).forEach(function (q) { led(q[0], q[1], g); });
    dim(g, 144);
    return g;
  };

  /* Personalizzati: name plate with lettering guides and a pen nib */
  LU.nome = function () {
    var g = svg(); var c = G(g);
    T('M-200 0 H200', c); T('M0 -200 V200', c);
    P('M-150 -64 H150 A16 16 0 0 1 166 -48 V64 A16 16 0 0 1 150 80 H-150 A16 16 0 0 1 -166 64 V-48 A16 16 0 0 1 -150 -64Z', g);
    T('M-150 -50 H150 V66 H-150Z', g);
    T('M-140 40 H140 M-140 -30 H140 M-140 8 H140', g);
    P('M-120 40 L-88 -30 L-56 40 M-108 14 H-68', g);
    C(-22, 25, 15, g); P('M-7 10 V40', g);
    P('M22 -34 V46', g);
    var n = G(g, 'translate(118 -120) rotate(35)');
    P('M0 -54 L16 -14 L8 30 L0 44 L-8 30 L-16 -14Z', n); T('M0 -10 V36', n); C(0, -8, 4, n);
    T('M-24 -60 H24', n);
    dim(g, 166, 130);
    return g;
  };

  /* Natale: ribbed tree (vase-mode) with a star */
  LU.albero = function () {
    var g = svg(); var c = G(g);
    T('M0 -200 V200', c); C(0, 0, 176, c, true);
    var ax = 0, ay = -138, by = 136, rx = 112, ry = 22;
    E(0, by, rx, ry, g);
    for (var i = 0; i <= 12; i++) {
      var th = i * 15, x = rx * Math.cos(th * R), y = by + ry * Math.sin(th * R);
      (i % 3 === 0 ? P : T)('M' + ax + ' ' + ay + ' Q' + f(x * 0.42) + ' ' + f((ay + y) * 0.42 + 24) + ' ' + pt(x, y), g);
    }
    P('M' + ax + ' ' + ay + ' Q-48 54 -112 136 M' + ax + ' ' + ay + ' Q48 54 112 136', g);
    P(poly(star(5, 24, 10, -90, 0, -164), true), g); led(0, -164, g);
    P('M-46 158 V180 M46 158 V180', g); E(0, 180, 46, 9, g);
    for (var j = 1; j < 12; j++) { var th2 = j * 15; led(rx * 0.9 * Math.cos(th2 * R), by + ry * 0.9 * Math.sin(th2 * R) - 4, g, 3); }
    return g;
  };

  /* Oggetti stampati: nozzle printing an isometric cube */
  LU.cubo = function () {
    var g = svg(); var c = G(g);
    T('M0 -200 V200', c); T('M-180 40 L0 144 L180 40', c);
    var Tp = [0, -46], Rp = [80, 0], Bp = [0, 46], Lp = [-80, 0], h = 96;
    P(poly([Tp, Rp, Bp, Lp], true), g);
    P(poly([Lp, [Lp[0], Lp[1] + h], [Bp[0], Bp[1] + h], [Rp[0], Rp[1] + h], Rp]), g);
    P('M0 46 V' + (46 + h), g);
    for (var y = 12; y < h; y += 12) { T('M-80 ' + y + ' L0 ' + (46 + y) + ' L80 ' + y, g); }
    T('M-40 -23 L40 23 M40 -23 L-40 23', g);
    P('M-10 -196 H10 V-150 H-10Z', g); P('M-34 -150 H34 V-112 H-34Z', g);
    T('M-34 -138 H34 M-34 -126 H34', g);
    P('M-16 -112 L0 -84 L16 -112', g);
    T('M0 -84 V-46', g); led(0, -84, g);
    dim(g, 80, 176);
    return g;
  };

  /* Biglietti: envelope with a card */
  LU.biglietto = function () {
    var g = svg(); frame(g, { r: 0 });
    P('M-112 0 V-150 H112 V0', g);
    T('M-92 -128 H92 M-92 -112 H40', g);
    P(poly(heartPts(2.6, 60).map(function (q) { return [q[0], q[1] - 62]; }), true), g);
    P('M-150 -6 H150 V150 H-150Z', g);
    P('M-150 -6 L0 84 L150 -6', g);
    T('M-150 150 L-36 62 M150 150 L36 62', g);
    led(0, -62, g);
    dim(g, 150, 180);
    return g;
  };

  /* Tutti i prodotti: four drawings on one sheet */
  LU.tavola = function () {
    var g = svg(); var c = G(g);
    T('M-200 0 H200 M0 -200 V200', c);
    [['corona', -102, -102], ['rosone', 102, -102], ['cuore', -102, 102], ['luna', 102, 102]].forEach(function (q) {
      var src = LU[q[0]] && LU[q[0]]();
      if (!src) return;
      var cell = G(g, 'translate(' + q[1] + ' ' + q[2] + ') scale(.44)');
      while (src.firstChild) cell.appendChild(src.firstChild);
    });
    return g;
  };

  /* Accessori auto: steering wheel */
  LU.volante = function () {
    var g = svg(); frame(g, { ticks: true });
    C(0, 0, 150, g); C(0, 0, 128, g); C(0, 0, 139, g, true);
    C(0, 0, 40, g); C(0, 0, 26, g, true);
    P('M-40 -6 C-70 -14 -100 -14 -128 -10 M-40 8 C-70 18 -100 18 -128 14', g);
    P('M40 -6 C70 -14 100 -14 128 -10 M40 8 C70 18 100 18 128 14', g);
    P('M-14 38 C-16 70 -18 100 -22 126 M14 38 C16 70 18 100 22 126', g);
    led(0, 0, g);
    dim(g, 150);
    return g;
  };

  /* Forme taglia biscotti: star cutter with depth */
  LU.formina = function () {
    var g = svg(); frame(g, {});
    var a = star(5, 140, 62, -90, -6, 4), b = star(5, 140, 62, -90, 6, -8);
    T(poly(b, true), g);
    P(poly(a, true), g);
    a.forEach(function (q, i) { T('M' + pt(q[0], q[1]) + ' L' + pt(b[i][0], b[i][1]), g); });
    T(poly(star(5, 122, 54, -90, -6, 4), true), g);
    dim(g, 134, 180);
    return g;
  };

  /* Estate: sun over the sea */
  LU.sole = function () {
    var g = svg(); var c = G(g);
    T('M-200 96 H200', c); T('M0 -200 V200', c); C(0, -40, 150, c, true);
    C(0, -40, 58, g); C(0, -40, 46, g, true);
    for (var i = 0; i < 16; i++) {
      var a = i * 22.5, p1 = polar(74, a, 0, -40), p2 = polar(i % 2 ? 100 : 122, a, 0, -40);
      P('M' + pt(p1[0], p1[1]) + ' L' + pt(p2[0], p2[1]), g);
    }
    [120, 146, 172].forEach(function (y, k) {
      var w = sample(function (x) { return [x, y + Math.sin((x + k * 30) / 24) * 6]; }, -170 + k * 20, 170 - k * 20, 60);
      (k === 1 ? T : P)(poly(w), g);
    });
    led(0, -40, g);
    return g;
  };

  /* Design: geometric luminaria, eight-point star */
  LU.ottagramma = function () {
    var g = svg(); frame(g, { ticks: true });
    P(poly(ngon(4, 150, -90), true), g); P(poly(ngon(4, 150, -45), true), g);
    T(poly(ngon(8, 150, -90), true), g);
    P(poly(star(8, 92, 56, -90), true), g); T(poly(ngon(8, 56, -67.5), true), g);
    C(0, 0, 22, g);
    ngon(8, 150, -90).concat(ngon(8, 92, -90)).forEach(function (q) { led(q[0], q[1], g); });
    led(0, 0, g);
    dim(g, 140);
    return g;
  };

  /* Per i più piccoli: hot-air balloon */
  LU.mongolfiera = function () {
    var g = svg(); var c = G(g);
    T('M0 -200 V200', c); C(0, -60, 140, c, true);
    P('M0 -176 C96 -176 132 -100 122 -44 C112 14 54 56 30 92 L-30 92 C-54 56 -112 14 -122 -44 C-132 -100 -96 -176 0 -176Z', g);
    T('M0 -176 C48 -170 66 -100 60 -44 C54 14 26 56 15 92 M0 -176 C-48 -170 -66 -100 -60 -44 C-54 14 -26 56 -15 92', g);
    T('M-124 -50 C-60 -36 60 -36 124 -50', g);
    P('M-30 92 L-22 128 M30 92 L22 128', g);
    P('M-26 128 H26 V160 H-26Z', g); T('M-26 140 H26', g);
    T('M-178 -120 C-170 -136 -146 -136 -140 -122 C-126 -126 -116 -110 -126 -100 H-176 C-190 -102 -190 -118 -178 -120Z', g);
    [[150, -150, 16], [170, -40, 9], [-160, 40, 11]].forEach(function (q) { P(poly(star(4, q[2], q[2] * .32, -90, q[0], q[1]), true), g); led(q[0], q[1], g); });
    dim(g, 122, 190);
    return g;
  };

  /* Wedding: two rings and a gem */
  LU.anelli = function () {
    var g = svg(); frame(g, {});
    C(-46, 20, 86, g); C(-46, 20, 72, g, true);
    C(46, 20, 86, g); C(46, 20, 72, g, true);
    P('M-70 -86 H-22 L-10 -72 L-46 -36 L-82 -72Z', g);
    T('M-82 -72 H-10 M-58 -86 L-64 -72 L-46 -36 L-28 -72 L-34 -86', g);
    [[-96, -110], [0, -96], [106, -84]].forEach(function (q, i) { P(poly(star(4, i === 0 ? 14 : 9, 3, -90, q[0], q[1]), true), g); led(q[0], q[1], g, 3); });
    dim(g, 132, 140);
    return g;
  };

  /* Halloween: pumpkin */
  LU.zucca = function () {
    var g = svg(); frame(g, { cy: 16 });
    E(0, 16, 150, 112, g); E(0, 16, 104, 112, g); E(0, 16, 46, 112, g, true);
    P('M-6 -94 C-8 -120 0 -140 22 -152 L30 -142 C14 -132 10 -116 10 -94', g);
    T('M22 -150 C40 -170 70 -160 74 -140', g);
    P('M-78 -14 L-40 -14 L-60 -46Z M78 -14 L40 -14 L60 -46Z', g);
    P('M-12 10 L0 -10 L12 10Z', g);
    P('M-96 44 L-70 60 L-48 44 L-24 62 L0 46 L24 62 L48 44 L70 60 L96 44 C70 92 -70 92 -96 44Z', g);
    led(-60, -24, g); led(60, -24, g);
    dim(g, 150, 180);
    return g;
  };

  /* Shopper: embroidered tote bag */
  LU.borsa = function () {
    var g = svg(); frame(g, { r: 0 });
    P('M-112 -40 H112 L120 160 H-120Z', g);
    T('M-100 -28 H100 L107 148 H-107Z', g);
    P('M-64 -40 C-64 -150 64 -150 64 -40 M-46 -40 C-46 -126 46 -126 46 -40', g);
    var hp = heartPts(3, 60).map(function (q) { return [q[0], q[1] + 50]; });
    P(poly(hp, true), g);
    for (var x = -30; x <= 30; x += 10) T('M' + x + ' 104 l6 6 M' + (x + 6) + ' 104 l-6 6', g);
    dim(g, 120, 190);
    return g;
  };

  /* Ricami: embroidery hoop, cross-stitch heart and needle */
  LU.telaio = function () {
    var g = svg(); frame(g, { r: 0 });
    C(0, 12, 140, g); C(0, 12, 126, g); C(0, 12, 112, g, true);
    P('M-14 -128 V-160 H14 V-128 M-24 -160 H24 M0 -160 V-184', g);
    var cells = [[-2, -1], [-1, -1], [1, -1], [2, -1], [-3, 0], [-2, 0], [-1, 0], [0, 0], [1, 0], [2, 0], [3, 0], [-2, 1], [-1, 1], [0, 1], [1, 1], [2, 1], [-1, 2], [0, 2], [1, 2], [0, 3]];
    cells.forEach(function (q) { var x = q[0] * 20, y = q[1] * 20 - 6; P('M' + (x - 7) + ' ' + (y - 7) + ' L' + (x + 7) + ' ' + (y + 7) + ' M' + (x + 7) + ' ' + (y - 7) + ' L' + (x - 7) + ' ' + (y + 7), g); });
    var n = G(g, 'translate(118 104) rotate(-40)');
    P('M0 -70 L3 40 L0 54 L-3 40Z', n); E(0, -60, 1.6, 6, n);
    T('M90 30 C110 70 60 110 20 100 C-10 92 -10 70 14 52', g);
    dim(g, 140, 186);
    return g;
  };

  /* Neon Led: neon tube on its board */
  LU.neon = function () {
    var g = svg(); var c = G(g);
    T('M-200 0 H200', c); T('M0 -200 V200', c);
    T('M-170 -100 H170 A12 12 0 0 1 182 -88 V88 A12 12 0 0 1 170 100 H-170 A12 12 0 0 1 -182 88 V-88 A12 12 0 0 1 -170 -100Z', g);
    [[-160, -78], [160, -78], [-160, 78], [160, 78]].forEach(function (q) { C(q[0], q[1], 7, g); });
    var d = 'M-140 40 C-120 -60 -80 -60 -80 0 C-80 60 -40 60 -30 0 C-20 -60 20 -60 30 0 C40 60 80 60 90 0 C100 -50 130 -50 140 -6';
    P(d, g); s('path', { d: d, transform: 'translate(0 9)' }, g, 'bp bp-thin');
    P('M-150 34 H-132 V52 H-150Z M134 -14 H152 V4 H134Z', g);
    T('M-141 52 C-141 120 -60 140 0 150 L0 200', g);
    [-80, -30, 30, 90].forEach(function (x) { led(x, 0, g, 3); });
    return g;
  };

  /* Prodotti luminosi: LED with rays */
  LU.led = function () {
    var g = svg(); var c = G(g);
    T('M0 -200 V200', c); C(0, -54, 128, c, true);
    P('M-42 62 V-54 A42 42 0 0 1 42 -54 V62Z', g);
    P('M-54 62 H54 V80 H-54Z', g);
    T('M-26 -54 A26 26 0 0 1 0 -80', g);
    P('M-18 80 V190 M18 80 V166 L30 154', g);
    for (var i = 0; i < 7; i++) { var a = -180 + 15 + i * 25, p1 = polar(70, a, 0, -54), p2 = polar(i % 2 ? 94 : 108, a, 0, -54); P('M' + pt(p1[0], p1[1]) + ' L' + pt(p2[0], p2[1]), g); }
    led(0, -40, g, 5);
    T('M-90 190 H90', g);
    return g;
  };

  /* Mother's Day: flower */
  LU.fiore = function () {
    var g = svg(); var c = G(g);
    T('M0 -200 V200', c); C(0, -60, 120, c, true);
    for (var i = 0; i < 8; i++) {
      var p = G(g, 'translate(0 -60) rotate(' + (i * 45) + ')');
      P('M0 -26 C26 -50 26 -90 0 -104 C-26 -90 -26 -50 0 -26Z', p); T('M0 -34 V-92', p);
    }
    C(0, -60, 24, g); led(0, -60, g, 5);
    P('M0 -36 C6 40 -10 110 0 190', g);
    P('M2 96 C30 70 70 74 84 92 C60 112 24 112 2 96Z M-2 140 C-28 116 -66 120 -80 138 C-56 156 -22 156 -2 140Z', g);
    T('M2 96 L70 90 M-2 140 L-66 136', g);
    return g;
  };

  /* Lumiè: organic bio lamp */
  LU.lumie = function () {
    var g = svg(); var c = G(g);
    T('M0 -200 V200', c); T('M-200 176 H200', c);
    var top = sample(function (t) { return [Math.cos(t) * 124, -40 - Math.sin(t) * 134]; }, 0, Math.PI, 48);
    var wave = sample(function (x) { return [x, 18 + Math.sin(x / 124 * Math.PI * 3.5) * 9]; }, -124, 124, 60);
    P(poly(top.concat([[-124, 18]], wave.slice(1).concat([[124, -40]])).concat([top[0]])), g);
    [-80, -36, 14, 62, 100].forEach(function (x, i) { T('M' + x + ' ' + (14 + (i % 2 ? 6 : -4)) + ' C' + (x * 0.8) + ' -60 ' + (x * 0.55) + ' -120 ' + (x * 0.2) + ' -172', g); });
    P('M-6 24 V160 M6 24 V160', g);
    E(0, 166, 74, 14, g); T('M-74 166 V178 C-74 188 74 188 74 178 V166', g);
    led(0, -30, g, 5);
    return g;
  };

  /* Zerbini della verità: coir doormat with engraved lettering */
  LU.zerbino = function () {
    var g = svg(); var c = G(g);
    T('M-200 0 H200', c); T('M0 -200 V200', c);
    P('M-170 -104 H170 V104 H-170Z', g);
    T('M-154 -88 H154 V88 H-154Z', g);
    P('M-112 -42 H112 V-14 H-112Z', g);
    P('M-80 14 H80 V40 H-80Z', g);
    for (var x = -150; x <= 150; x += 20) T('M' + x + ' 94 v8 M' + x + ' -102 v8', g);
    T('M-104 -28 H104 M-72 27 H72', g);
    dim(g, 170, 140);
    return g;
  };

  /* Stampa 3D: printer gantry */
  LU.stampante = function () {
    var g = svg(); var c = G(g);
    T('M0 -200 V200', c); T('M-200 160 H200', c);
    P('M-150 160 V-170 H150 V160', g);
    P('M-170 160 H170 V176 H-170Z', g);
    T('M-128 160 V-150 M128 160 V-150', g);
    P('M-128 -70 H128', g); T('M-128 -60 H128', g);
    P('M-34 -96 H34 V-48 H-34Z', g); P('M-12 -48 L0 -26 L12 -48', g);
    P('M-110 108 H110 V120 H-110Z', g);
    P('M-30 108 C-34 70 -22 40 -26 10 H26 C22 40 34 70 30 108', g);
    for (var y = 20; y < 108; y += 14) T('M-27 ' + y + ' H27', g);
    T('M0 -26 V10', g); led(0, -26, g);
    return g;
  };
})();
